import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Icon } from '../Icon';

interface ButtonMoreProps {
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
}

const Layout = styled.button<Partial<ButtonMoreProps>>`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: ${toRem(33)};
  height: ${toRem(33)};
  margin: 0;
  padding: 0;
  border-radius: ${toRem(5.5)};
  background-color: transparent;
  transition: background-color ${theme.transition.button.fast};

  svg {
    fill: ${theme.color.neutral[400]};
    transition: fill ${theme.transition.button.fast};
  }

  &:hover {
    background-color: ${theme.color.neutral[100]};

    svg {
      fill: ${theme.color.neutral[900]};
    }
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${theme.color.neutral[100]};

      svg {
        fill: ${theme.color.neutral[900]};
      }
    `}
`;

const ButtonMore: React.FC<ButtonMoreProps> = ({ isActive, onClick, className }) => (
  <Layout aria-label="Toggle Menu" isActive={isActive} onClick={onClick} className={className}>
    <Icon icon="More" width={20} height={20} />
  </Layout>
);

export default ButtonMore;
